import { useState } from 'react';
import { Button } from '@/components/ui/button';

const COLL = { expenses: 'Expense', salary_payments: 'Salary', supplier_payments: 'Supplier pmt' };

const toCsv = (items) => {
  const head = ['type', 'reference', 'id', 'date', 'created_at', 'amount', 'branch_id', 'payment_mode', 'party', 'notes'];
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  return [head.join(','), ...items.map((r) => [COLL[r.collection] || r.collection, r.reference, r.id, r.date, r.created_at, r.amount,
    r.branch_id, r.payment_mode, r.party, r.notes].map(esc).join(','))].join('\n');
};

// Read-only list of the transactions flagged "needs journal review" (Ledger Health).
export const LedgerReviewItems = ({ items = [], branchName = (id) => id }) => {
  const [open, setOpen] = useState(false);
  if (!items.length) return null;
  const download = () => {
    const url = URL.createObjectURL(new Blob([toCsv(items)], { type: 'text/csv' }));
    Object.assign(document.createElement('a'), { href: url, download: 'journal-review-items.csv' }).click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="w-full" data-testid="ledger-review-items">
      <div className="flex gap-2">
        <Button size="sm" variant="ghost" className="rounded-full text-xs" onClick={() => setOpen(!open)} data-testid="ledger-review-toggle">
          {open ? 'Hide items' : `View ${items.length} items`}
        </Button>
        {open && <Button size="sm" variant="ghost" className="rounded-full text-xs" onClick={download} data-testid="ledger-review-csv">Download CSV</Button>}
      </div>
      {open && (
        <div className="mt-2 max-h-80 overflow-auto rounded-lg border bg-white/70 dark:bg-black/20">
          <table className="w-full text-[11px]" data-testid="ledger-review-table">
            <thead className="sticky top-0 bg-muted">
              <tr className="text-left">{['Type', 'Reference', 'Date', 'Branch', 'Mode', 'Party', 'Notes'].map((h) => <th key={h} className="p-1.5">{h}</th>)}
                <th className="p-1.5 text-right">Amount</th></tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={`${r.collection}-${r.id}`} className="border-t" data-testid={`ledger-review-row-${r.id}`}>
                  <td className="p-1.5">{COLL[r.collection] || r.collection}</td>
                  <td className="p-1.5 font-mono">{r.reference}</td>
                  <td className="p-1.5">{r.date}</td>
                  <td className="p-1.5">{branchName(r.branch_id)}</td>
                  <td className="p-1.5">{r.payment_mode}</td>
                  <td className="p-1.5">{r.party}</td>
                  <td className="p-1.5 max-w-[220px] truncate" title={r.notes}>{r.notes}</td>
                  <td className="p-1.5 text-right">{Number(r.amount).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
